import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import moment from 'moment';

@Component({
  selector: 'app-next-step-form',
  templateUrl: './next-step-form.component.html',
  styleUrls: ['./next-step-form.component.scss'],
  standalone: false,
})
export class NextStepFormComponent implements OnInit {
  @Input() nextStepForm: FormGroup;
  today: string = moment().format('YYYY-MM-DD');

  ngOnInit(): void {
    this.nextStepForm.controls['description'].valueChanges.subscribe((value) => {
      if (value?.length >= 3) {
        this.nextStepForm.controls['due_date'].setValidators([Validators.required]);
      } else {
        this.nextStepForm.controls['due_date'].setValidators([]);
      }
      this.nextStepForm.controls['due_date'].updateValueAndValidity();
    });
  }
}
